export default __webpack_public_path__ + "static/media/user-group-blue.5f2ad248.svg";